import { FC } from 'react'
import { useTheme } from '@opallabs/hooks'
import * as styles from '../../InputLabel/styles'

type RadioLegendProps = {
  disabled?: boolean
  required?: boolean
}

export const RadioLegend: FC<React.PropsWithChildren<RadioLegendProps>> = ({
  children,
  disabled = false,
  required = false,
}) => {
  const theme = useTheme()
  return (
    <legend
      css={styles.label({ theme })}
      aria-disabled={disabled}
      data-required={required}
    >
      {children}
    </legend>
  )
}
RadioLegend.displayName = 'Lapidary: Radio.Legend'
